import * as React from 'react'

const ErrorPage = ({
  title,
  children
}: {
  title: string
  children: React.ReactNode
}) => {
  return (
    <section className="page-section">
      <div className="grid-container">
        <header className="fds-u-text-align-center">
          <h1 className="fds-c-text-heading -size-xxl">{title}</h1>
          {children}
        </header>
      </div>
    </section>
  )
}

export default ErrorPage
